import clsx from 'clsx';
import * as React from 'react';
import { Box } from '../Box';
import { Icon } from '../Icon/Icon';
import { useResponsiveProp } from '../../utils/useResponsiveProp';
import './ButtonIcon.css';
import { Text } from '../Text';
export const ButtonIcon = React.forwardRef(function ButtonIcon(props, ref) {
    const { src, size: userSize = 'small', elementType = 'button', className, label, variant = 'secondary', ...restProps } = props;
    const computedUserSize = useResponsiveProp(userSize);
    const elementProps = getElementProps(elementType, props);
    return (React.createElement(Box.Restricted, { ...restProps, ...elementProps, ref: ref, elementType: elementType, className: clsx('mollie-ui-button-icon', `mollie-ui-button-icon--${computedUserSize}`, `mollie-ui-button-icon--${variant}`, className) },
        React.createElement(Icon, { src: src, className: "mollie-ui-button-icon-internal-icon" }),
        label && React.createElement(Text, { variant: "caption-medium" }, label)));
});
ButtonIcon.displayName = 'ButtonIcon';
function getElementProps(elementType, props) {
    const buttonProps = props;
    const linkProps = props;
    switch (elementType) {
        case 'button': {
            return { type: 'button' };
        }
        case 'a': {
            return {
                disabled: undefined,
                'aria-disabled': buttonProps.disabled,
                href: buttonProps.disabled ? undefined : linkProps.href,
            };
        }
        default: {
            return {
                disabled: buttonProps.disabled,
                'aria-disabled': buttonProps.disabled,
                href: buttonProps.disabled ? undefined : linkProps.href,
            };
        }
    }
}
//# sourceMappingURL=ButtonIcon.js.map